"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var contests_core_1 = require("@biw/contests-core");
exports.default = react_redux_1.connect(function (state) { return ({ locale: contests_core_1.translations.selectors.getUserLocale(state) }); });
//# sourceMappingURL=locale-enhancer.js.map